module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-44.fdb37806.png";